module.exports = __webpack_public_path__ + "static/media/random.48d7784f.svg";